import React from 'react'
import {BrowserRouter as Router, Route} from 'react-router-dom'
import {Container} from 'react-bootstrap' 
import HomeScreen from './screens/HomeScreen'
import Header from './components/Header'
import Footer from './components/Footer'
import AppPage from './screens/HomeScreen___old'
import ProductScreen from './screens/ProductScreen'
import CartScreen from './screens/CartScreen'
import LoginScreen from './screens/LoginScreen'
import RegisterScreen from './screens/RegisterScreen'
import ProfileScreen from './screens/ProfileScreen'
import ShippingScreen from './screens/ShippingScreen'
import PaymentScreen from './screens/PaymentScreen'
import PlaceOrderScreen from './screens/PlaceOrderScreen'
import OrderScreen from './screens/OrderScreen'
import UserListScreen from './screens/UserListScreen'
import UserEditScreen from './screens/UserEditScreen'
import ProductListScreen from './screens/ProductListScreen'
import ProductEditScreen from './screens/ProductEditScreen'
import ManageProduct from './screens/ManageProduct'
import RegistarEvent from './screens/RegistarEvent'
import SearchProduct from './screens/SearchProduct'
import OrderListScreen from './screens/OrderListScreen'
import UsereventScreen from './screens/UsereventScreen'
import EditRegistryScreen from './screens/EditRegistryScreen';
import Settings from './screens/settings';
import PageDesign from './screens/PageDesign';

const App=()=> {
  return (
    <Router>      
            <Route path='/' component={HomeScreen}/>
            <Route path='/order/:id' component={OrderScreen}/>
            <Route path='/shipping' component={ShippingScreen}/>
            <Route path='/payment' component={PaymentScreen}/>
            <Route path='/placeOrder' component={PlaceOrderScreen}/>
            <Route path='/login' component={LoginScreen}/>
            <Route path='/register' component={RegisterScreen}/>
            <Route path='/evm-gift-registry' component={AppPage}/>
            <Route path='/settings' component={Settings}/>
            <Route path='/ManageProduct' component={ManageProduct}/>        
            <Route path='/page-design' component={PageDesign}/>
            <Route path='/user-event/:id' component={UsereventScreen}/>
            <Route path='/profile' component={ProfileScreen}/>
            <Route path='/product/:id' component={ProductScreen}/>
            <Route path='/cart/:id?' component={CartScreen}/>
            <Route path='/admin/userList' component={UserListScreen}/>
            <Route path='/admin/user/:id/edit' component={UserEditScreen}/>
            <Route path='/admin/productList' component={ProductListScreen} exact/>
            <Route path='/admin/productList/:pageNumber' component={ProductListScreen} exact/>
            <Route path='/admin/product/:id/edit' component={ProductEditScreen}/>
            <Route path='/admin/orderList' component={OrderListScreen}/>
            <Route path='/search/:keyword' component={HomeScreen} exact/>
            <Route path='/page/:pageNumber' component={HomeScreen} exact/>
            <Route path='/search/:keyword/page/:pageNumber' component={HomeScreen} exact/>            
            <Route path="/admin/editRegistry/:id" component={EditRegistryScreen} />       
            {/* <Route path='/shopline/' component={ManageProduct} exact/>
            <Route path='/shopline/:pageNumber' component={ManageProduct} exact/>
            <Route path='/shopline/:pageNumber' component={RegistarEvent} exact/>
            <Route path='/shopline/:pageNumber' component={SearchProduct} exact/>
            <Route path='/admin/productList' component={HomeScreen} exact/> */}            
      <Footer/>
    </Router>
  );
}

export default App;
